/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineWithoutModuleQueryResponse,
  GetApiV1ClassroomdisciplineWithoutModuleQueryParams,
  GetApiV1ClassroomdisciplineWithoutModule400,
  GetApiV1ClassroomdisciplineWithoutModule401,
  GetApiV1ClassroomdisciplineWithoutModule404,
  GetApiV1ClassroomdisciplineWithoutModule500,
} from "../../types/classPlanningController/GetApiV1ClassroomdisciplineWithoutModule.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineWithoutModule } from "../../clients/classPlanningController/getApiV1ClassroomdisciplineWithoutModule.ts";

export const getApiV1ClassroomdisciplineWithoutModuleQueryKey = (
  params?: GetApiV1ClassroomdisciplineWithoutModuleQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline/without-module" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineWithoutModuleQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineWithoutModuleQueryKey
>;

export function getApiV1ClassroomdisciplineWithoutModuleQueryOptions(
  params?: GetApiV1ClassroomdisciplineWithoutModuleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ClassroomdisciplineWithoutModuleQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineWithoutModuleQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineWithoutModule400
      | GetApiV1ClassroomdisciplineWithoutModule401
      | GetApiV1ClassroomdisciplineWithoutModule404
      | GetApiV1ClassroomdisciplineWithoutModule500
    >,
    GetApiV1ClassroomdisciplineWithoutModuleQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineWithoutModule(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Lista as Aulas (ativas) de uma Disciplina que ainda não estão vinculadas a um Módulo. Os filtros de data (startDate/endDate, por DateStart) são opcionais — cada limite só é aplicado quando informado. **(Requer Authorization para autenticação)**
 * @summary Listar Aulas de uma Disciplina sem Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/without-module}
 */
export function useGetApiV1ClassroomdisciplineWithoutModule<
  TData = GetApiV1ClassroomdisciplineWithoutModuleQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineWithoutModuleQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ClassroomdisciplineWithoutModuleQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineWithoutModuleQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineWithoutModuleQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ClassroomdisciplineWithoutModule400
          | GetApiV1ClassroomdisciplineWithoutModule401
          | GetApiV1ClassroomdisciplineWithoutModule404
          | GetApiV1ClassroomdisciplineWithoutModule500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineWithoutModuleQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineWithoutModuleQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineWithoutModule400
      | GetApiV1ClassroomdisciplineWithoutModule401
      | GetApiV1ClassroomdisciplineWithoutModule404
      | GetApiV1ClassroomdisciplineWithoutModule500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
